// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3CVOz","col":"styles_col__3MQO6"};